import React, { Component } from 'react';

import ThemeContext from '../../contexts/ThemeContext';

import './ThemedLink.scss';

// For use of <a> theme in other react libs which use anchor, such as react-router etc.
export let CSSClassName = 'themedLink';

class ThemedLink extends Component {
	static contextType = ThemeContext;
	render(){
		return (
			<a
				{...this.props}
				className={`${this.props.className || ''} ${CSSClassName} ${this.context.isDarkTheme ? `${CSSClassName}--dark` : ''}`}
			>
				{this.props.children}
			</a>
		)
	}
}

export default ThemedLink;